import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import styles from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewEdgeStates.module.scss"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

export default function CardsViewHiddenByScheduleHorizonState() {
    const { objectName, hiddenByScheduleHorizonCount, setIsViewMenuOpen } = useObjectsView()

    const objectLabel = objectName.toLowerCase()

    return (
        <div className={styles.base}>
            <EmptyState
                variant="default"
                icon={faIcon({ name: "calendar", style: "regular" })}
                title={`No ${pluralize(objectLabel)} within the schedule horizon`}
                supportText={
                    <>
                        <span className={styles.emphasis}>
                            {hiddenByScheduleHorizonCount} {pluralize(objectLabel, hiddenByScheduleHorizonCount)}
                        </span>{" "}
                        hidden by schedule horizon
                    </>
                }
                primaryCTA={{ children: "Show settings", onClick: () => setIsViewMenuOpen(true), noDebounce: true }}
            />
        </div>
    )
}
